<template>
<div>
  <v-layout row wrap justify-center>
    <v-flex class="px-2 py-3" xs12 md7>
      <v-btn 
        v-if="!courseData.published"
        @click.native="popup.show = true, popup.type = 'Publishing'"
        class="mx-2 my-0"
        color="success"
        :loading="updating"
        :disabled="updating"
        depressed
      >Publish</v-btn>
      <v-btn
        v-else
        @click.native="popup.show = true, popup.type = 'Unpublishing'"
        class="mx-2 my-0"
        color="error"
        :loading="updating"
        :disabled="updating"
        depressed
      >Unpublish</v-btn>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 md7>
      <v-select
        label="Live or Online?"
        v-model="newCourse.type"
        @blur="updateName"
        :items="['Live', 'Online']"
        hide-details
        disabled
      ></v-select>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12>
      <v-text-field
        label="Course Name"
        v-model="newCourse.name"
        :disabled="!canEdit"
        :readonly="newCourse.type == 'Live'"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex class="px-2 pb-3" xs6 md3>
      <v-select
        label="Course Subject"
        v-model="newCourse.subject"
        @blur="updateName"
        :items="['RN', 'PN', 'CPR', 'IV']"
        :disabled="!canEdit"
        hide-details
      ></v-select>
    </v-flex>
    <v-flex class="px-2 pb-3" xs6 md3>
      <v-text-field
        label="Course Price"
        v-model="newCourse.price"
        :disabled="!canEdit"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex class="px-2 pb-3" xs6 md3>
      <v-text-field
        label="# of Days Online"
        v-model="newCourse.onlineDays"
        @blur="updateName"
        :disabled="!canEdit"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex class="px-2 pb-3" xs6 md3>
      <v-text-field
        label="# of Live Classes"
        v-model="live"
        @blur="updateName"
        hide-details
        disabled
      ></v-text-field>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12>
      <v-select
        label="Content"
        v-model="newCourse.content"
        :items="contentNames"
        :disabled="!canEdit"
        hide-details
        multiple
        chips
      ></v-select>
    </v-flex>
    <template v-if="newCourse.type == 'Live'">
      <v-flex class="px-2 pb-3" xs6 md3>
        <v-select
          label="Instructor"
          v-model="newCourse.instructor"
          :items="['Ms. Mo', 'ONLINE']"
          :disabled="!canEdit"
          hide-details
          readonly
        ></v-select>
      </v-flex>
      <v-flex class="px-2 pb-3" xs6 md3>
        <v-menu
          ref="startTimeMenu"
          :close-on-content-click="false"
          v-model="startTimeMenu"
          :nudge-right="40"
          :return-value.sync="startTime"
          transition="scale-transition"
          min-width="290px"
          max-width="290px"
          offset-y
          full-width
          lazy>
          <v-text-field
            v-if="canEdit"
            label="Start Time"
            slot="activator"
            v-model="newCourse.startTime"
            hide-details
            readonly
          ></v-text-field>
          <v-time-picker
            v-model="startTime"
            @change="$refs.startTimeMenu.save(startTime), updateName()"
          ></v-time-picker>
        </v-menu>
        <v-text-field
          v-if="!canEdit"
          label="Start Time"
          v-model="newCourse.startTime"
          hide-details
          disabled
        ></v-text-field>
      </v-flex>
      <v-flex class="px-2 pb-3" xs6 md3>
        <v-menu
          ref="endTimeMenu"
          :close-on-content-click="false"
          v-model="endTimeMenu"
          :nudge-right="40"
          :return-value.sync="endTime"
          transition="scale-transition"
          min-width="290px"
          max-width="290px"
          offset-y
          full-width
          lazy>
          <v-text-field
            v-if="canEdit"
            label="End Time"
            slot="activator"
            v-model="newCourse.endTime"
            hide-details
            readonly
          ></v-text-field>
          <v-time-picker
            v-model="endTime"
            @change="$refs.endTimeMenu.save(endTime), updateName()"
          ></v-time-picker>
        </v-menu>
        <v-text-field
          v-if="!canEdit"
          label="End Time"
          v-model="newCourse.endTime"
          hide-details
          disabled
        ></v-text-field>
      </v-flex>
      <v-flex class="px-2 pb-3" xs6 md3>
        <v-text-field
          label="Max. # of Students"
          v-model="newCourse.maxStudents"
          disabled
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="px-2 pb-3" xs12>
        <v-text-field
          label="Roster Location"
          v-model="newCourse.location"
          :disabled="!canEdit"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="px-2 pb-1" xs12>
        <v-select
          label="Dates"
          v-model="newCourse.dates"
          :items="newCourse.dates"
          append-icon="backspace"
          :append-icon-cb="() => (removeDate())"
          :disabled="!canEdit"
          hide-details
          multiple
          chips
          readonly
        ></v-select>
      </v-flex>
      <v-flex class="px-2 pb-3 text-xs-center" xs12>
        <v-menu
          :close-on-content-click="false"
          v-model="pickingDate"
          transition="scale-transition"
          :nudge-right="40"
          min-width="290px"
          :return-value.sync="dateChoice"
          full-width
          offset-y
          lazy
        >
          <v-btn
            slot="activator"
            color="primary"
            class="my-0"
            depressed
            small
          >Add Dates</v-btn>
          <v-date-picker v-model="dateChoice" no-title scrollable>
            <v-btn @click="addDate" color="success" :disabled="!canEdit" depressed small>Add</v-btn>
            <v-btn @click="pickingDate = false" color="error" flat small>Close</v-btn>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </template>
    <v-flex class="px-1 pb-3 text-xs-center" xs12>
      <v-btn @click.native="canUpdate" :loading="updating" :disabled="updating" color="success" depressed large>
        Save
      </v-btn>
      <v-btn @click.native="popup.show = true, popup.type='Resetting'" color="error" flat large>
        <b>Reset</b>
      </v-btn>
    </v-flex>
  </v-layout>

  <r-course-popup
    :popup="popup"
    :new-course="newCourse"
  ></r-course-popup>
</div>
</template>

<script>
import {coursesEvent} from '../../main'
import CoursePopup from './CoursePopup.vue'
export default {
  components: {
    rCoursePopup: CoursePopup
  },
  data: () => ({
    loading: false,
    updating: false,
    publishing: false,
    pickingDate: false,
    dateChoice: null,
    startTimeMenu: false,
    startTime: null,
    endTimeMenu: false,
    endTime: null,
    allCourses: [],
    contentNames: [],
    courseData: {},
    newCourse: {},
    live: '',
    popup: {
      show: false,
      type: ''
    }
  }),
  computed: {
    now () {
      return this.$store.getters.now
    },
    progress () {
      return this.$store.getters.progress
    },
    studentCount () {
      let count = 0
      const linked = this.$store.getters.linkedCourses(this.courseData.key)
      for (let c of linked) {
        if (c.students) {
          for (let s of c.students) {
            if (this.hasProgress(s.uid)) count += 1
          }
        }
      }
      return count
    },
    canEdit () {
      if (this.studentCount > 0) return false
      return !this.courseData.published
    }
  },
  beforeMount () {
    this.load()
    coursesEvent.$on('updateCourse', () => {
      this.updateCourse()
    })
    coursesEvent.$on('reset', () => {
      this.resetNewCourse()
    })
    coursesEvent.$on('publish', () => {
      this.togglePublish(true)
    })
    coursesEvent.$on('unpublish', () => {
      this.togglePublish(false)
    })
  },
  methods: {
    load () {
      this.loading = true
      this.courseData = {...this.$store.getters.courseByKey(this.$route.params.courseKey)}
      this.courseData.content = this.courseData.content ? [...this.courseData.content] : []
      this.courseData.dates = this.courseData.dates ? [...this.courseData.dates] : []
      const c = [...this.$store.getters.content]
      for (let content of c) {
        this.contentNames.push(content.name)
      }
      this.allCourses = [...this.$store.getters.courses]
      let keys = [...this.courseData.content]
      this.courseData.content = []
      for (let key of keys) {
        for (let content of c) {
          if (content.key === key) this.courseData.content.push(content.name)
        }
      }
      this.resetNewCourse()
      this.loading = false
    },
    resetNewCourse () {
      this.newCourse = {
        ...this.courseData,
        content: this.courseData.content ? [...this.courseData.content] : [],
        dates: this.courseData.dates ? [...this.courseData.dates] : [],
        students: this.courseData.students ? [...this.courseData.students] : []
      }
    },
    changed () {
      let changeMade = false
      let name = this.courseData.name.toLowerCase() !== this.newCourse.name.toLowerCase()
      let price = this.courseData.price !== this.newCourse.price
      let onlineDays = this.courseData.onlineDays !== this.newCourse.onlineDays
      let subject = this.courseData.subject !== this.newCourse.subject
      let roster = this.courseData.roster !== this.newCourse.roster
      let content = !this.$store.getters.arrayEquals(this.courseData.content, this.newCourse.content)
      changeMade = name || price || onlineDays || roster || subject || content
      if (this.courseData.type === 'Live') {
        let instructor = this.courseData.instructor !== this.newCourse.instructor
        let startTime = this.courseData.startTime !== this.newCourse.startTime
        let endTime = this.courseData.endTime !== this.newCourse.endTime
        let maxStudents = this.courseData.maxStudents !== this.newCourse.maxStudents
        let location = this.courseData.location !== this.newCourse.location
        let dates = !this.$store.getters.arrayEquals(this.courseData.dates, this.newCourse.dates)
        changeMade = changeMade || instructor || startTime || endTime || maxStudents || location || dates
      }
      return changeMade
    },
    canUpdate () {
      if (this.changed()) {
        const digit = this.$store.getters.reg.digit
        const appMsg = {
          type: 'error',
          msg: ''
        }
        if (this.newCourse.type === '' || this.newCourse.name === '') {
          appMsg.msg = this.newCourse.type === '' ? 'Please choose a course type' : 'Please enter a name for the course'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (this.newCourse.name.length < 3) {
          appMsg.msg = 'Course name has to be longer than 2 characters'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newCourse.price === '') {
          appMsg.msg = 'Please enter a course price'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (!digit.test(this.newCourse.price) || parseInt(this.newCourse.price, 10) <= 0) {
          appMsg.msg = 'Please enter only numbers greater than 0 for course price'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newCourse.onlineDays === '') {
          appMsg.msg = 'Please enter course Online Days in # of Days'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else if (!digit.test(this.newCourse.onlineDays) || parseInt(this.newCourse.onlineDays, 10) <= 0) {
          appMsg.msg = 'Please enter only numbers greater than 0 for course Online Days'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newCourse.type === 'Live') {
          if (this.newCourse.location === '') {
            appMsg.msg = 'Please enter a location for the course'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newCourse.dates.length === 0 || this.newCourse.startTime === '' || this.newCourse.endTime === '') {
            appMsg.msg = this.newCourse.dates.length === 0 ? 'Please choose dates for the course' : 'Please enter course times'
            this.$store.dispatch('showAppMsg', appMsg)
            return
          }
          if (this.newCourse.maxStudents === '') {
            appMsg.msg = 'Please enter max # of students allowed'
            this.$store.dispatch('showAppMsg', appMsg)
          } else if (!digit.test(this.newCourse.maxStudents) || parseInt(this.newCourse.maxStudents, 10) <= 0) {
            appMsg.msg = 'Please enter only numbers greater than 0 for max # of students'
            this.$store.dispatch('showAppMsg', appMsg)
          }
        }
        if (this.newCourse.type === 'Online' && this.newCourse.content.length === 0) {
          appMsg.msg = 'Please choose at least one content for the course'
          this.$store.dispatch('showAppMsg', appMsg)
        }
        for (let course of this.allCourses) {
          if (this.newCourse.name.toLowerCase() === course.name.toLowerCase() && this.$store.getters.arrayEquals(this.newCourse.content, course.content)) {
            if (this.newCourse.onlineDays === course.onlineDays) {
              appMsg.msg = 'An identical course already exists!'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        }
        this.popup = {
          show: true,
          type: 'Updating Course'
        }
      } else {
        const appMsg = {
          type: 'error',
          msg: 'No change detected'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    updateCourse () {
      this.updating = true
      let nameChanged = this.courseData.name.toLowerCase() !== this.newCourse.name.toLowerCase()
      if (this.newCourse.type === 'Online') {
        this.newCourse.liveClasses = '0'
        this.newCourse.dates = null
        this.newCourse.startTime = null
        this.newCourse.endTime = null
        this.newCourse.location = null
        this.newCourse.maxStudents = null
      }
      this.getContentKeys()
      if (!this.publishing) {
        for (let course of this.allCourses) {
          if (this.newCourse.name.toLowerCase() === course.name.toLowerCase() && this.$store.getters.arrayEquals(this.newCourse.content, course.content)) {
            if (this.newCourse.onlineDays === course.onlineDays) {
              const appMsg = {
                type: 'success',
                msg: 'An identical course already exists!'
              }
              this.$store.dispatch('showAppMsg', appMsg)
              this.updating = false
              this.load()
              return
            }
          }
        }
      }
      this.$store.dispatch('updateCourse', this.newCourse).then(c => {
        const appMsg = {
          type: 'success',
          msg: 'Course ' + this.courseData.name + ' updated!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.updating = false
        this.publishing = false
        if (nameChanged) this.$router.push('/manage-courses')
        else this.load()
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.updating = false
        this.publishing = false
      })
    },
    getContentKeys () {
      const c = this.$store.getters.content
      let names = [...this.newCourse.content]
      this.newCourse.content = []
      for (let name of names) {
        for (let content of c) {
          if (name === content.name) this.newCourse.content.push(content.key)
        }
      }
    },
    updateName () {
      if (this.newCourse.type === 'Live') {
        this.newCourse.name = ''
        if (this.newCourse.subject.toUpperCase() === 'RN' || this.newCourse.subject.toUpperCase() === 'PN') {
          this.newCourse.name += this.newCourse.subject.toUpperCase() + ' Review'
        } else this.newCourse.name += this.newCourse.subject.toUpperCase()
        if (this.newCourse.dates.length > 0) {
          let dateString = new Date(this.newCourse.dates[0]).toDateString().split(' ')
          this.newCourse.name += (' ' + dateString[1] + ' ' + dateString[2])
        }
        if (this.startTime) this.newCourse.startTime = this.formatTime(this.startTime)
        if (this.endTime) this.newCourse.endTime = this.formatTime(this.endTime)
        this.newCourse.name += ' ' + this.newCourse.startTime
      }
    },
    formatTime (time) {
      let timeString = ''
      let t = time.split(':')
      let hour = parseInt(t[0])
      let mins = parseInt(t[1])
      let dateTime = new Date(0, 0, 0, hour, mins, 0, 0)
      let timeParts = dateTime.toLocaleTimeString().split(' ')
      timeString = timeParts[0].split(':')
      timeString = timeString[0] + ':' + timeString[1] + timeParts[1]
      return timeString
    },
    togglePublish (pub) {
      this.publishing = true
      this.resetNewCourse()
      const startDate = this.newCourse.type === 'Live' ? new Date(this.newCourse.dates[0]).valueOf() : Number.POSITIVE_INFINITY
      if (pub && this.now > startDate) {
        const appMsg = {
          type: 'error',
          msg: 'Publish failed; start date has already passed'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      } else {
        this.newCourse.published = pub
        this.getContentKeys()
        this.$store.dispatch('updateCourse', this.newCourse).then(c => {
          const appMsg = {
            type: 'success',
            msg: pub ? 'Course ' + this.courseData.name + ' published!' : 'Course ' + this.courseData.name + ' unpublished!'
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.updating = false
          this.publishing = false
          this.load()
        }).catch(err => {
          const appMsg = {
            type: 'error',
            msg: err.message
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.updating = false
          this.publishing = false
        })
      }
    },
    addDate () {
      if (this.dateChoice) {
        this.newCourse.dates.push(new Date(this.dateChoice.split('-')).toLocaleDateString())
      }
      this.updateName()
    },
    removeDate () {
      this.newCourse.dates.pop()
      this.updateName()
    },
    hasProgress (uid) {
      const linkedKeys = []
      for (let c of this.$store.getters.linkedCourses(this.courseData.key)) {
        linkedKeys.push(c.key)
      }
      let rightProgress = false
      let notEnded = false
      for (let p of this.progress) {
        rightProgress = p.studentId === uid && linkedKeys.includes(p.courseKey)
        notEnded = p.endTime === 0 || this.now < p.endTime
        if (rightProgress && notEnded) return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/EditCourse.vue